<template>
    <LoadingIconSvg class="loading-spinner" :style="{ '--size': `${size}px` }" />
</template>

<script>
import LoadingIconSvg from '@/assets/icons/loader.svg';
export default {
    name: 'LoadingSpinner',
    props: {
        size: {
            type: Number,
            default: 24,
        },
    },
    components: {
        LoadingIconSvg,
    },
}
</script>

<style scoped>
.loading-spinner {
    width: var(--size, 24px);
    height: var(--size, 24px);
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>